import React, { Component } from 'react';
import '../assets/css/App.css';
import '../assets/css/progress.css';
import ChatMessage from './chatMessageComponent';
import Header from './header-components/header.component'
import { globalConstants } from '../constants/globalConstants';
import HeaderActionType from '../enums/action-types/HeaderActionType';
import GlobalStoreService from '../services/global-store.service';
import GLOBAL_CONFIG from '../config/config';
import UtilService from '../services/util.service';
import IdleTimeoutService from "../services/idle-timeout.service";
import PopUp from './common-components/popup'
import ConfirmationBox from './common-components/confirmation-box.component'
import TrackingMiddlewareService from '../services/tracking-middleware.service';
import TrackingKey from '../enums/trackingKey'

class ChatApp extends Component {
    constructor(props) {
        super(props);
        window.pageName = globalConstants.TRACKING_EVENTS_CONSTANTS.pageName;
        GlobalStoreService.set("platformType", UtilService.getPlatformType());
        // set global app context 
        if (window.MyAirtelChatAppReact) {
            GlobalStoreService.set("APP_CONTEXT", window.MyAirtelChatAppReact);
        }
        else if (window.MyAirtelAppReact) {
            GlobalStoreService.set("APP_CONTEXT", window.MyAirtelAppReact);
        }
        else {
            GlobalStoreService.set("APP_CONTEXT", undefined);
        }
        this.feedbackRequired = false;
        this.state = {
            isChatOpen: true,
            showCloseBanner: false,
            isMinimize: false,
            showHeader: (GlobalStoreService.get("APP_CONTEXT")) ? false : true,
            isFocussedInApp: false,
            popupVisible: true,
            showCloseChatConfirmationPopup: false
        }
        IdleTimeoutService.trackIdleChat();
    }

    handleHeaderClick = (params) => {
        IdleTimeoutService.updateIdleState();
        if (params.actionType === HeaderActionType.MINIMIZE) {
            this.setState({
                isMinimize: true, popupVisible: false
            })
        } else if (params.actionType === HeaderActionType.MAXIMIZE) {
            this.setState({
                isMinimize: false, popupVisible: true
            })
        } else if (params.actionType === HeaderActionType.CLOSE) {
            if (!GlobalStoreService.get("APP_CONTEXT")) {
                window.parent.postMessage("MAXIMIZE", GLOBAL_CONFIG.parentOrigin);
            }
            this.setState({
                isMinimize: false,
                showCloseBanner: true,
                popupVisible: true,
                showCloseChatConfirmationPopup: true
            })
            this.showPopup(
                <ConfirmationBox
                    title={'Close Chat'}
                    messages={['Do you wish to close this session?']}
                    buttons={[
                        {
                            label: 'NO',
                            onClick: () => {
                                this.showPopup(undefined)
                                this.submitCloseSessionFromUser('NO')
                            }
                        },
                        {
                            highlight: true,
                            label: 'YES',
                            onClick: () => {

                                this.showPopup(undefined)
                                this.submitCloseSessionFromUser('YES')


                            }
                        },
                    ]} />)

        }

    }

    submitCloseSessionFromUser = (value) => {
        IdleTimeoutService.updateIdleState();
        if (value === "YES") {
            window.parent.postMessage("CLOSE_CHAT_WINDOW", GLOBAL_CONFIG.parentOrigin);
            if (this.feedbackRequired && this.trackingKey) {
                TrackingMiddlewareService.trackEvent(this.trackingKey)
            }
            this.setState({
                isChatOpen: false,
                showCloseChatConfirmationPopup: false
            });
            // TRACKING CLOSE CHAT YES SELECT
            TrackingMiddlewareService.trackEvent(TrackingKey.CLOSE_CHAT_YES)

        } else {
            this.setState({
                showCloseBanner: false,
                showCloseChatConfirmationPopup: false
            });
            // TRACKING CLOSE CHAT NO SELECT
            TrackingMiddlewareService.trackEvent(TrackingKey.CLOSE_CHAT_NO)
        }
    }
    showPopup = (popup_comp) => {
        if (popup_comp)
            this.setState({ show_popup: true, popup_data: popup_comp })
        else
            this.setState({ show_popup: false, popup_data: undefined })
    }

    setFeedbackRequired = (feedbackRequired, trackingKey) => {

        this.feedbackRequired = feedbackRequired
        this.trackingKey = trackingKey
    }

    render() {
        const showheader = this.state.showHeader;
        return (
            <div className={(this.state.isMinimize) ? 'open' : ''}>
                {!this.state.show_multiple_user_accounts_screen &&

                    this.state.isChatOpen ?
                    <main id="main" style={{ maxWidth: '100%', maxHeight: '100%' }}>

                        {/* --Chat Header-----*/}
                        {showheader &&
                            <Header
                                handleHeaderClick={this.handleHeaderClick}
                                isMinimized={this.state.isMinimize}
                            />
                        }

                        {/* ---Message List-----*/}
                        <ChatMessage
                            ref={(ourComponent) => { window.ourComponent = ourComponent }}
                            isMaximized={!this.state.isMinimize}
                            hideMessagePopup={this.state.show_popup}
                            showCloseChatConfirmationPopup={this.state.showCloseChatConfirmationPopup}
                            setFeedbackRequired={this.setFeedbackRequired}
                        />

                    </main>
                    : null}
                {this.state.show_popup && this.state.popup_data && PopUp(this.state.popup_data, this.state.popupVisible)}
            </div>
        );
    }
}

export default ChatApp;



// WEBPACK FOOTER //
// ./src/components/chat-app-component.js